import React, { useState, useEffect } from "react";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import { useDispatch } from "react-redux";
import * as actionUrl from "../../store/actions";

const auctionDetailId =
  window.location.pathname &&
  window.location.pathname.split("/") &&
  window.location.pathname.split("/")[2]
    ? atob(
        window.location.pathname &&
          window.location.pathname.split("/") &&
          window.location.pathname.split("/")[2]
      )
    : "";
const userId =
  window.location.pathname &&
  window.location.pathname.split("/") &&
  window.location.pathname.split("/")[3]
    ? atob(
        window.location.pathname &&
          window.location.pathname.split("/") &&
          window.location.pathname.split("/")[3]
      )
    : "";

function MBTTime() {
  const dispatch = useDispatch();
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const [sessionRunningFlag, setsessionRunningFlag] = useState("");
  const [reconnectAttempts, setReconnectAttempts] = useState(0);

  useEffect(() => {
    let socket = null;
    let stompClient = null;
    let reconnectTimer = null;
    let isMounted = true;

    const MAX_RECONNECT_ATTEMPTS = 5;
    const INITIAL_RECONNECT_DELAY = 1000; // 1 second
    const MAX_RECONNECT_DELAY = 30000; // 30 seconds

    const calculateReconnectDelay = (attempts) => {
      return Math.min(
        INITIAL_RECONNECT_DELAY * Math.pow(2, attempts),
        MAX_RECONNECT_DELAY
      );
    };

    const cleanup = () => {
      if (stompClient !== null) {
        stompClient.disconnect();
      }
      if (socket !== null) {
        socket.close();
      }
      if (reconnectTimer) {
        clearTimeout(reconnectTimer);
      }
    };

    const subscribeCall = () => {
      if (!stompClient || !isMounted) return;

      stompClient.subscribe(
        "/englishauction/broadcast/getheaderdata/" + auctionDetailId,
        (message) => {
          if (message.body && isMounted) {
            const [part1, part2, part3] = message.body.split("$$");
            if (part1 != 0) {
              const remainingTimeInSeconds = parseInt(part1);
              setRemainingSeconds(remainingTimeInSeconds);
            }
            
            if (part3 == 6) {
              setsessionRunningFlag("");
            }
            else if (part1 > 0 || part2 > 0) {
              setsessionRunningFlag(1);
            }  
            else {
              setsessionRunningFlag(2);
            }
          }
        }
      );

      stompClient.subscribe(
        "/englishauction/broadcast/holdAuction/" + auctionDetailId,
        (message) => {
          if (message.body && isMounted) {
            setsessionRunningFlag("");
          }
        }
      );

      stompClient.subscribe(
        "/englishauction/broadcast/auctionend/" + auctionDetailId,
        (message) => {
          if (message.body && isMounted) {
            if (
              window.location.pathname.split("/")[4] != undefined &&
              window.location.pathname.split("/")[5] != undefined &&
              window.location.pathname.split("/")[3] != undefined
            ) {
              setsessionRunningFlag(2);
            }
          }
        }
      );
    };

    const connectWebSocket = () => {
      if (!isMounted) return;

      cleanup(); // Clean up any existing connections

      let url =
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_END_POINT_URL_DEV
          : process.env.REACT_APP_END_POINT_URL_PROD;

      // Connect to the server using SockJS
      socket = new SockJS(
        url +
          "/englishauction/connect?token=" +
          atob(sessionStorage.getItem("argument1"))
      );

      // Create a Stomp.js client over the WebSocket connection
      stompClient = Stomp.over(socket);
      stompClient.debug = () => {}; // Suppress debug logs

      stompClient.connect(
        {},
        () => {
          console.log("Connected to WebSocket server");
          setReconnectAttempts(0); // Reset reconnect attempts on successful connection
          subscribeCall();

          // Send the message after connection is established
          console.log("Sending message...");
          stompClient.send(
            "/englishauction/send/getheaderdata/" + auctionDetailId,
            {},
            auctionDetailId
          );
        },
        (error) => {
          console.error("WebSocket connection error:", error);
          if (isMounted) {
            handleReconnect();
          }
        }
      );

      // Handle unexpected disconnections
      socket.onclose = () => {
        console.log("WebSocket closed unexpectedly");
        if (isMounted) {
          handleReconnect();
        }
      };
    };

    const handleReconnect = () => {
      if (!isMounted || reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) return;

      const delay = calculateReconnectDelay(reconnectAttempts);
      console.log(`Attempting to reconnect in ${delay / 1000} seconds...`);

      reconnectTimer = setTimeout(() => {
        if (isMounted) {
          setReconnectAttempts((prev) => prev + 1);
          connectWebSocket();
        }
      }, delay);
    };

    // Initial connection
    connectWebSocket();

    // Cleanup function
    return () => {
      isMounted = false;
      cleanup();
    };
  }, []);

  // Update remaining seconds every second
  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingSeconds((prevSeconds) => (prevSeconds > 0 ? prevSeconds - 1 : 0));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Convert remaining seconds to hours, minutes, and seconds
  const hours = Math.floor(remainingSeconds / 3600);
  const minutes = Math.floor((remainingSeconds % 3600) / 60);
  const seconds = remainingSeconds % 60;

  return (
    <>
      {sessionRunningFlag != "" ?  
        <div>
          <span>
            <b> 
              {sessionRunningFlag == 1
                ? "Your current session is running"
                : sessionRunningFlag == 2
                ? "Your current session has ended"
                : ""}
            </b>
          </span>
          <span className="divider"></span>
        </div>
      : ""}
      <div>
        <div>
          <b>MBT : </b>
          {remainingSeconds !== 0 && (
            <>
              <span>
                {hours > 9 ? hours : hours < 0 ? "0" + "0" : "0" + hours}
              </span>
              :
              <span>
                {minutes > 9 ? minutes : minutes < 0 ? "0" + "0" : "0" + minutes}
              </span>
              :
              <span>
                {seconds > 9 ? seconds : seconds < 0 ? "0" + "0" : "0" + seconds}
              </span>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default MBTTime;